<script setup lang="ts">
import { useRouter } from 'vue-router'
import { onBackClick } from '@/router/goBack'

// The header of a page like the todo list's: an optional back arrow, the title and a hint line below it.
const router = useRouter()
const props = defineProps<{
  title: string
  hint?: string
  backTo?: string
  backLabel?: string
}>()
</script>

<template>
  <header class="page-header">
    <RouterLink
      v-if="backTo"
      :to="backTo"
      class="back"
      :aria-label="backLabel"
      @click="onBackClick($event, router, props.backTo as string)"
      >‹</RouterLink
    >
    <div class="title">
      <h2>{{ title }}</h2>
      <span v-if="hint" class="ui-hint">{{ hint }}</span>
    </div>
    <slot />
  </header>
</template>

<style scoped>
.page-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}

.back {
  font-size: 1.8rem;
  line-height: 1;
  text-decoration: none;
}

.title {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

h2 {
  margin: 0;
  font-size: 1.3rem;
  overflow-wrap: anywhere;
}
</style>
